'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.load = load;
exports.loadSuccess = loadSuccess;
exports.loadFail = loadFail;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'languages/LOAD';
var LOAD_SUCCESS = 'languages/LOAD_SUCCESS';
var LOAD_FAIL = 'languages/LOAD_FAIL';

var initialState = {
  items: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state);
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        items: action.res.items
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        errors: action.err.errors
      });
    default:
      return state;
  }
}

function load() {
  return {
    type: LOAD
  };
}

function loadSuccess(res) {
  return {
    type: LOAD_SUCCESS,
    res: res
  };
}

function loadFail(err) {
  return {
    type: LOAD_FAIL,
    err: err
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/language.js
// module id = 1247
// module chunks = 0